import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * Keeps the 30-day lowest-price line on the selected variant.
 *
 * @extends {Component}
 */
class ProductLowestPriceComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('product-card, .shopify-section, dialog');
    if (!target) return;
    target.addEventListener(ThemeEvents.variantUpdate, this.updateLowestPrice);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.closest('product-card, .shopify-section, dialog');
    if (!target) return;
    target.removeEventListener(ThemeEvents.variantUpdate, this.updateLowestPrice);
  }

  /**
   * @param {VariantUpdateEvent} event
   */
  updateLowestPrice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId &&
      this.dataset.productId &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    // Card variant updates render `section-rendering-product-card`, which has
    // the line but not this block's id. Prefer a block match, then fall back.
    const incomingRoot =
      (this.dataset.blockId &&
        event.detail.data.html.querySelector(
          `product-lowest-price-component[data-block-id="${this.dataset.blockId}"]`
        )) ||
      event.detail.data.html.querySelector('product-lowest-price-component');
    const incomingLine = incomingRoot
      ? incomingRoot.querySelector('.product-lowest-price')
      : event.detail.data.html.querySelector('.product-lowest-price');
    const currentLine = this.querySelector('.product-lowest-price');
    const host = this.querySelector('.product-card-meta') || this;

    if (currentLine && incomingLine) {
      morph(currentLine, incomingLine);
      return;
    }

    if (currentLine && !incomingLine) {
      currentLine.remove();
      return;
    }

    if (!currentLine && incomingLine) {
      host.appendChild(incomingLine.cloneNode(true));
    }
  };
}

if (!customElements.get('product-lowest-price-component')) {
  customElements.define('product-lowest-price-component', ProductLowestPriceComponent);
}
